import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, ShoppingBag, X } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { useCart } from "@/lib/cart";

const NAV = [
  { to: "/", label: "Inicio", end: true },
  { to: "/productos", label: "Productos" },
  { to: "/como-funciona", label: "Cómo funciona" },
  { to: "/nuestra-historia", label: "Nuestra historia" },
];

const linkCls = ({ isActive }) =>
  `text-[0.8rem] tracking-[0.12em] uppercase transition-colors ${isActive ? "text-[#080808]" : "text-[#080808]/60 hover:text-[#080808]"}`;

export const SiteHeader = () => {
  const [open, setOpen] = useState(false);
  const { data: cart } = useCart();
  return (
    <header className="sticky top-0 z-40 border-b border-[#EAE7E2] bg-[#FAF8F4]/90 backdrop-blur-xl">
      <div className="mx-auto flex max-w-[1400px] items-center justify-between gap-4 px-5 sm:px-8 lg:px-12 h-[76px] lg:h-[96px]">
        <Link to="/" data-testid="header-logo-link" aria-label="LUMINA STUDIO, inicio" className="shrink-0">
          <Logo className="h-[60px] w-[60px] lg:h-[78px] lg:w-[78px]" />
        </Link>
        <nav className="hidden lg:flex items-center gap-9" aria-label="Principal">
          {NAV.map((n) => <NavLink key={n.to} to={n.to} end={n.end} className={linkCls} data-testid={`nav-${n.to.replace(/\//g, "") || "inicio"}`}>{n.label}</NavLink>)}
        </nav>
        <div className="flex items-center gap-2 sm:gap-4">
          <Link to="/personalizar" data-testid="header-customize-button"
            className="hidden lg:inline-flex rounded-full bg-[#080808] px-6 py-3 text-[0.75rem] font-medium uppercase tracking-[0.16em] text-[#FAF8F4] transition-colors hover:bg-[#B18A4B]">
            Personaliza tu LUMINA
          </Link>
          <Link to="/carrito" data-testid="header-cart-link" aria-label="Carrito" className="relative grid h-11 w-11 place-items-center rounded-full text-[#080808] hover:bg-[#EAE7E2] transition-colors">
            <ShoppingBag className="h-5 w-5" />
            {cart?.count > 0 && <span data-testid="header-cart-count" className="absolute right-0.5 top-0.5 grid h-5 min-w-5 place-items-center rounded-full bg-[#B18A4B] px-1 text-[0.6rem] font-semibold text-white">{cart.count}</span>}
          </Link>
          <button data-testid="mobile-menu-toggle" aria-label={open ? "Cerrar menú" : "Abrir menú"} aria-expanded={open}
            onClick={() => setOpen((o) => !o)} className="lg:hidden grid h-11 w-11 place-items-center rounded-full hover:bg-[#EAE7E2] transition-colors">
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>
      {open && (
        <nav data-testid="mobile-menu" aria-label="Principal" className="lg:hidden border-t border-[#EAE7E2] bg-[#FAF8F4] px-5 pb-6 pt-2">
          {NAV.map((n) => (
            <NavLink key={n.to} to={n.to} end={n.end} onClick={() => setOpen(false)}
              className="block border-b border-[#EAE7E2] py-4 font-serif-display text-2xl text-[#080808]">{n.label}</NavLink>
          ))}
          <Link to="/personalizar" onClick={() => setOpen(false)} data-testid="mobile-customize-button"
            className="mt-6 flex justify-center rounded-full bg-[#080808] py-4 text-xs font-medium uppercase tracking-[0.16em] text-[#FAF8F4]">
            Personaliza tu LUMINA
          </Link>
        </nav>
      )}
    </header>
  );
};
